import React, { useState, useContext, useMemo } from "react";
import styled, { css } from "styled-components";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
import { getValueFromInput } from "util/FormsUtils";
import { Button, Checkbox, Col, FormControl, ListGroup, ListGroupItem, Row } from "components/bootstrap";
import { Spinner } from "components/common";
import StreamsContext from "contexts/StreamsContext";
const StyledSpinner = styled(Spinner)`
  margin-top: 7px;
`;
const StyledListGroupItem = styled(ListGroupItem)(
  ({ theme }) => css`
    background-color: ${theme.colors.variant.lightest.default};
    padding-bottom: 7px;
    padding-top: 5px;
    color: ${theme.utils.contrastingColor(theme.colors.variant.lightest.default)};
    margin: 0;
  `
);
const StyledCol = styled(Col)`
  padding-left: 0;
`;
const ScrollableListWrapper = styled.div`
  position: relative;

  .scrollable-list {
    margin-top: 5px;
    max-height: 425px;
    overflow-y: auto;
  }

  .scrollable-list-header {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    display: block;
    z-index: 10;
  }
  .scrollable-list-item:nth-child(2) {
    margin-top: 40px;
    border-top: none;
  }
`;
const ArchiveConfigStreamSelectionForm = ({ excludedStreams = [], updateExcludedStreams }) => {
  const availableStreams = useContext(StreamsContext);
  const [filter, setFilter] = useState(void 0);
  const streams = useMemo(
    () => availableStreams ? [...availableStreams].sort((a, b) => naturalSort(a.title, b.title)) : [],
    [availableStreams]
  );
  const onUpdateCheckbox = (streamId) => (e) => {
    let newExcludes = excludedStreams.slice(0);
    if (e.target.checked) {
      if (newExcludes.indexOf(streamId) !== -1) {
        newExcludes = newExcludes.filter((id) => id !== streamId);
      }
    } else if (newExcludes.indexOf(streamId) === -1) {
      newExcludes.push(streamId);
    }
    updateExcludedStreams(newExcludes);
  };
  const onSelectAll = (event) => {
    let newExcludes = [];
    if (!event.target.checked) {
      newExcludes = streams.map((stream) => stream.id);
    }
    updateExcludedStreams(newExcludes);
  };
  const onFilterChange = (event) => {
    setFilter(getValueFromInput(event.target));
  };
  const onFilterReset = () => {
    setFilter(void 0);
  };
  const isStreamIncluded = (stream) => excludedStreams && excludedStreams.indexOf(stream.id) === -1;
  const filterListItem = () => /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { xs: 9, md: 6 }, /* @__PURE__ */ React.createElement(
    FormControl,
    {
      type: "text",
      onChange: onFilterChange,
      placeholder: "Filter streams",
      value: filter
    }
  )), /* @__PURE__ */ React.createElement(StyledCol, { xs: 3, md: 2 }, /* @__PURE__ */ React.createElement(Button, { onClick: onFilterReset }, "Reset")));
  const headerItem = () => /* @__PURE__ */ React.createElement(StyledListGroupItem, { className: "scrollable-list-header scrollable-list-item", key: "stream-select-all" }, /* @__PURE__ */ React.createElement(Checkbox, { onChange: onSelectAll }, "Select all available streams"));
  const streamItems = () => {
    const items = streams.filter((stream) => {
      const text = `${stream.title} ${stream.description}`;
      return !(filter && text.toLowerCase().indexOf(filter.toLowerCase()) === -1);
    }).map((stream) => /* @__PURE__ */ React.createElement(ListGroupItem, { key: `stream-${stream.id}`, className: "scrollable-list-item" }, /* @__PURE__ */ React.createElement(Checkbox, { checked: isStreamIncluded(stream), onChange: onUpdateCheckbox(stream.id) }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", null, stream.title), " - ", stream.description))));
    if (items.length > 0) {
      return items;
    }
    return /* @__PURE__ */ React.createElement(ListGroupItem, { className: "scrollable-list-item" }, "No streams match the filter.");
  };
  if (!availableStreams) {
    return /* @__PURE__ */ React.createElement(StyledSpinner, { text: "Loading streams..." });
  }
  return /* @__PURE__ */ React.createElement("div", null, filterListItem(), /* @__PURE__ */ React.createElement(ScrollableListWrapper, { className: "scrollable-list-container" }, /* @__PURE__ */ React.createElement(ListGroup, { className: "scrollable-list" }, headerItem(), streamItems())));
};
export default ArchiveConfigStreamSelectionForm;
